<template>
  <div class="document">
    <div class="header">
        <Es-header>
          <template #header>
            <div class="header-title">
              Add Note
            </div>
          </template>
        </Es-header>
    </div>
    <div class="content" style="padding: 1rem 0">
      <es-loader v-if="loading" style="margin: 6.5rem"/>
      <es-exception v-else-if="loadingError"
        style="padding: 6.5rem"
        margin="0rem" size="4x"
        exceptionMessage="There was an issue. Please contact the admin"
      />
      <es-form>
        <template #es-form>
          <div class="row removeUnderline">
            <div class="field is-horizontal ">
              <div class="field-label is-normal">
                <label class="label"
                  for="noteDateInputAddNoteForm">
                  Note Date
                </label>
              </div>
              <div class="field-body">
                <div class="field">
                  <div class="control">
                    <input type="text"
                      style="width: 500px"
                      disabled
                      :value="getNewDate() | formatDateMMDDYYYY"
                      id="noteDateInputAddNoteForm"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row removeUnderline">
            <div class="field is-horizontal">
              <div class="field-label is-normal">
                <label class="label"
                  for="noteCretedByInputAddNoteForm">
                  Created By
                </label>
              </div>
              <div class="field-body">
                <div class="field">
                  <div class="control">
                    <div class="">
                      <input type="text"
                        disabled
                        style="width: 500px"
                        :value="createdByDisplayName"
                        id="noteCretedByInputAddNoteForm"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row removeUnderline">
            <div class="field is-horizontal">
              <div class="field-label is-normal">
                <label class="label">
                  Type
                </label>
              </div>
              <div class="field-body">
                <div class="field">
                  <div class="control">
                    <div class="buttons has-addons">
                      <button
                        v-for="(option, index) in availableNoteTypeOptions"
                        :key="index"
                        class="button button--form"
                        @click="selectedNoteType = option.code; clearErrors()"
                        :class="{
                          'is-active': selectedNoteType === option.code,
                        }"
                        style="min-width: 100px"
                      >
                        {{ option.description }}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
            <div class="row removeUnderline">
              <div class="field is-horizontal">
                <div class="field-label is-normal">
                  <label class="label"
                    for="noteControlAddNoteForm">
                    Note
                  </label>
                </div>
                <div class="field-body">
                  <div class="field">
                    <div class="control">
                      <div>
                        <textarea
                          v-model="noteContent"
                          class="textarea"
                          :class="{'is-danger' : hasErrorNoteContent}"
                          type="text"
                          @click="resetNotifications"
                          @keypress="validateNoteContentField()"
                          id="noteControlAddNoteForm"
                        ></textarea>
                        <span
                          v-if="hasErrorNoteContent"
                          class="help is-danger"
                        >
                          {{ msgNoteContent }}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
        </template>
      </es-form>
      <div
        class="is-flex flex-justify--end flex-align--center"
        style="margin-right: 5.15rem; padding-bottom: 2rem"
      >
        <router-link
          :to="{
            name: 'PidMasterRecord',
            query: {
              retired: isRetired,
            },
          }"
          style="margin-right: 1rem;"
        >
          Cancel
        </router-link>
        <button
          class="button is-primary"
          @click="submitNote()"
        >
          Add Note
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import axios from 'axios';
import EsException from '@/components/EsException.vue';
import EsForm from '@/components/EsForm.vue';
import EsHeader from '@/components/EsHeader.vue';
import EsLoader from '@/components/EsLoader.vue';
import NotificationManager from '@/mixins/NotificationManager';
import PermissionManager from '@/mixins/PermissionManager';

export default {
  components: {
    EsException,
    EsForm,
    EsHeader,
    EsLoader,
  },
  mixins: [
    NotificationManager,
    PermissionManager,
  ],
  props: {
    id: {
      type: String,
      required: true,
    },
    isRetired: {
      type: Boolean,
      default: false,
    },
    person: {
      type: Object,
      required: true,
    },
  },
  data() {
    return this.initialData();
  },
  created() {
    this.noteTypeOptions = [
      {
        code: 'ADMIN',
        description: 'Admin',
        permission: 'PRSID:PRPRF:NOTES:ADD:ADMIN',
      },
      {
        code: 'GENERAL',
        description: 'General',
        permission: 'PRSID:PRPRF:NOTES:ADD:GENERAL',
      },
    ];
    this.selectedNoteType = this.availableNoteTypeOptions.length === 1 ? this.availableNoteTypeOptions[0].code : 'GENERAL';
  },
  computed: {
    createdByDisplayName() {
      return `${this.$store.state.user.lastName}, ${this.$store.state.user.firstName}`;
    },
    availableNoteTypeOptions() {
      return this.noteTypeOptions.filter(p => this.hasModule(p.permission));
    },
  },
  methods: {
    clearErrors() {
      this.hideNotification();
      this.hasErrorNoteContent = false;
      this.msgNoteContent = null;
    },
    getNewDate() {
      return new Date();
    },
    initialData() {
      return {
        formErrorMsg: 'There were some errors. Please fix the errors highlighted in the fields below.',
        hasErrorNoteContent: false,
        loading: false,
        loadingError: false,
        msgNoteContent: null,
        noteContent: null,
        selectedNoteType: null,
      };
    },
    refreshNotes() {
      const sort = [{
        field: 'lastUpdateDate',
        order: 'DESC',
      }];
      const params = new URLSearchParams();
      params.append('sort', JSON.stringify(sort));
      params.append('type', this.selectedNoteType);
      return axios.get(`person/${this.id}/notes`, { params });
    },
    resetNotifications() {
      this.$store.state.notifications.isActive = false;
      this.$store.state.notifications.notificationType = null;
    },
    showError(error) {
      this.showNotification('danger', [error]);
    },
    async submitNote() {
      this.validateNoteContentField();
      if (this.hasErrorNoteContent) {
        this.showNotification('danger', [this.formErrorMsg]);
        return;
      }
      try {
        this.loading = true;
        this.loadingError = false;
        axios.post(`person/${this.id}/notes`, {
          type: this.selectedNoteType,
          personType: this.person.personType,
          personId: this.id,
          content: this.noteContent,
        });
      } catch (error) {
        this.loadingError = true;
      } finally {
        this.loading = false;
        this.refreshNotes();
        this.$root.$emit('reloadPerson');
        this.$router.push({
          name: 'PidMasterRecord',
          query: {
            retired: this.isRetired,
          },
        });
      }
    },
    validateNoteContentField() {
      this.resetNotifications();
      if (!this.noteContent || this.noteContent === '') {
        this.hasErrorNoteContent = true;
        this.msgNoteContent = 'Note content is required.';
      } else if (this.noteContent.length > 300) {
        this.hasErrorNoteContent = true;
        this.msgNoteContent = 'Note allows a maximum of 300 characters.';
      } else {
        this.hasErrorNoteContent = false;
        this.msgNoteContent = null;
      }
    },
  },
  filters: {
    formatDateMMDDYYYY(value) {
      if (value) {
        return moment(value).format('MM/DD/YYYY');
      }
      return 'N/A';
    },
  },
};
</script>

<style lang="sass" scoped>
</style>
